import type { Dispatch } from "react";
import type { EditorAction } from "../editor/reducers";
import type { RowGroup } from "./types";
import { mdiTableMergeCells, mdiTableSplitCell } from "@mdi/js";
import { TableEditorStep } from "./TableEditorStep";
import { AccessButton } from "@acdc2/ui/components/access-button";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";

type Props = {
  dispatch: Dispatch<EditorAction>;
  soleTableGroup: RowGroup | undefined;
  isSelectionAtomic: boolean;
  isSingleCellSelected: boolean;
  isSelectionRectangular: boolean;
};

export function TableEditorStep4({
  dispatch,
  soleTableGroup,
  isSelectionAtomic,
  isSingleCellSelected,
  isSelectionRectangular,
}: Props) {
  const { t } = useTranslation();

  return (
    <TableEditorStep
      value="step4"
      iconPath={mdiTableSplitCell}
      title={t("TableEditorStep4.title")}
      description={t("TableEditorStep4.description")}
    >
      <div className="grid grid-cols-2 gap-2">
        <AccessButton
          type="button"
          variant="outline"
          onClick={() => dispatch({ type: "mergeTableCell" })}
          disabled={
            isSingleCellSelected || !isSelectionRectangular || !soleTableGroup
          }
        >
          <Icon path={mdiTableMergeCells} size="1rem" />
          {t("TableEditorStep4.inputs.merge.label")}
        </AccessButton>
        <AccessButton
          type="button"
          variant="outline"
          onClick={() => dispatch({ type: "splitTableCell" })}
          disabled={isSelectionAtomic}
        >
          <Icon path={mdiTableSplitCell} size="1rem" />
          {t("TableEditorStep4.inputs.split.label")}
        </AccessButton>
      </div>
    </TableEditorStep>
  );
}
